import React from 'react';

interface IEngineProps {
  width?: number;
  height?: number;
}

const Engine: React.FC<IEngineProps> = ({ width = 24, height = 24 }) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="engine-penta"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.75 4.577a.5.5 0 0 1 .5-.5h7.125a.5.5 0 0 1 0 1h-3.063v1.375H15.3c.418 0 .735.219.949.463a2.4 2.4 0 0 1 .457.866l.222 1.085a.3.3 0 0 0 .066.119c.008.008.053.05.214.05h1.917a.5.5 0 0 1 .5.5v1.648h.46v-.497a.5.5 0 0 1 .778-.416l.916.614a.5.5 0 0 1 .222.415v5.83a.5.5 0 0 1-.222.416l-.916.613a.5.5 0 0 1-.779-.415v-.574h-.459v1.716a.5.5 0 0 1-.5.5h-2.07c-.123 0-.206.044-.346.117l-.01.006c-.268.315-.631.414-.941.414H8.004c-.198 0-.4-.084-.53-.149a1.7 1.7 0 0 1-.431-.302l-2.578-2.506a.4.4 0 0 0-.102-.03q-.033-.006-.032-.005h-.916C2.602 16.93 2 16.32 2 15.51V9.68c0-.838.707-1.421 1.416-1.421.287 0 .467-.048.578-.095a.6.6 0 0 0 .21-.138l1.065-1.113a.5.5 0 0 1 .137-.1l.106-.062.003-.002c.052-.032.12-.073.192-.112.127-.068.359-.185.61-.185h3.996V5.077H7.25a.5.5 0 0 1-.5-.5m4.048 2.875H6.327l-.024.008a1 1 0 0 0-.121.057q-.074.04-.155.09l-.008.005-.082.048-1.016 1.061-.006.007c-.244.245-.675.531-1.5.531a.43.43 0 0 0-.416.42v5.83c0 .264.16.421.416.421h.916c.147 0 .298.034.417.074.1.034.268.1.392.223l2.602 2.53.006.005a.75.75 0 0 0 .27.157l.009.003h7.73c.06 0 .101-.01.127-.022a.16.16 0 0 0 .068-.061.5.5 0 0 1 .192-.17l.044-.024c.134-.075.466-.26.868-.26h1.57V16.67a.5.5 0 0 1 .5-.5h1.458a.5.5 0 0 1 .417.223V11.96a.5.5 0 0 1-.417.223h-1.459a.5.5 0 0 1-.5-.5v-1.648h-1.417c-.37 0-.67-.11-.892-.315a1.3 1.3 0 0 1-.361-.622l-.223-1.085a1.4 1.4 0 0 0-.236-.44c-.092-.105-.156-.12-.196-.12h-4.502"
        clipRule="evenodd"
      />
    </svg>
  </>
);

export default Engine;
